"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGitMetadata = void 0;
const simple_git_1 = __importDefault(require("simple-git"));
const tags_1 = require("../tags");
const utils_1 = require("../utils");
const get_git_data_1 = require("./get-git-data");
const getGitMetadata = (repositoryPath) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const git = (0, simple_git_1.default)({
            baseDir: repositoryPath || process.cwd(),
            binary: 'git',
            // We are invoking at most 5 git commands at the same time.
            maxConcurrentProcesses: 5,
        });
        const [commitSHA, branch, repositoryUrl, message, authorAndCommitter] = yield Promise.all([
            (0, get_git_data_1.gitHash)(git),
            (0, get_git_data_1.gitBranch)(git),
            (0, get_git_data_1.gitRepositoryURL)(git),
            (0, get_git_data_1.gitMessage)(git),
            (0, get_git_data_1.gitAuthorAndCommitter)(git),
        ]);
        const { authorName, authorEmail, authorDate, committerName, committerEmail, committerDate } = authorAndCommitter;
        return {
            [tags_1.GIT_REPOSITORY_URL]: (0, utils_1.filterSensitiveInfoFromRepository)(repositoryUrl.trim()),
            [tags_1.GIT_BRANCH]: branch.current,
            [tags_1.GIT_SHA]: commitSHA,
            [tags_1.GIT_COMMIT_MESSAGE]: message.trim(),
            [tags_1.GIT_COMMIT_COMMITTER_DATE]: committerDate.trim(),
            [tags_1.GIT_COMMIT_COMMITTER_EMAIL]: committerEmail.trim(),
            [tags_1.GIT_COMMIT_COMMITTER_NAME]: committerName.trim(),
            [tags_1.GIT_COMMIT_AUTHOR_DATE]: authorDate.trim(),
            [tags_1.GIT_COMMIT_AUTHOR_EMAIL]: authorEmail.trim(),
            [tags_1.GIT_COMMIT_AUTHOR_NAME]: authorName.trim(),
        };
    }
    catch (e) {
        return {};
    }
});
exports.getGitMetadata = getGitMetadata;
//# sourceMappingURL=format-git-span-data.js.map